export const apiUrl = process.env.REACT_APP_APIURL === 'PRODUCTION' ? window.location.origin : process.env.REACT_APP_APIURL;